<template>
  <a
    :href="url"
    target="_blank"
    rel="noopener nofollow"
    @click="click"
    :aria-label="account.type"
  >
    <component :is="getSocialIconComponentName(account.type)" title=" " />
  </a>
</template>

<script>
import {
  SOCIAL_ACCOUNT_ICONS,
  getSocialIconComponentName,
} from '@campsite-bio/component-lib';
import startCase from 'lodash/startCase';

import { appendUTMParams } from '@/utils/utm-param';

export default {
  components: {
    ...SOCIAL_ACCOUNT_ICONS,
  },

  props: {
    account: {
      type: Object,
      required: true,
    },
    campsite: Object,
    isFreePlan: Boolean,
  },

  setup() {
    return { getSocialIconComponentName, startCase };
  },

  computed: {
    url() {
      if (this.account.type === 'email') return `mailto:${this.account.url}`;

      if (this.campsite.enable_utm_parameters && !this.isFreePlan) {
        const utmMedium = this.campsite.utm_medium;
        const utmSource = this.campsite.utm_source;
        return appendUTMParams(
          this.account.url,
          utmMedium,
          utmSource,
          this.account.type,
        );
      } else return this.account.url;
    },
  },

  methods: {
    click() {
      this.$track(
        {
          campsite_id: this.campsite._id.$oid,
          link_id: this.account._id.$oid,
          social_type: this.account.type,
          type: 'social',
        },
        { href: this.account.url, text: this.account.type },
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
